export const api_host='https://api-i.atentus.com'
//export const api_host='https://api-ih.atentus.com'
//export const api_host='http://0.0.0.0:8000'
//export const api_host='http://0.0.0.0:8082'
//export const api_host='http://10.0.43.42:8089'


export const api_auth='07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2'


export const atWeb = ["atTransaction Plus 2.0", "atTransaction 2.0", "atTransaction 2.0 CC", "AtTransaction 2.0 con digipass", "atTransaction Plus 2.0 V2", "AtTransaction Plus 2.0 Especial", "AtTransaction Plus 2.0 Digipass Especial"]
export const atIvr = ["AtIVR Monitoreo para centrales IVR"]
export const atMobile = ["AtAppMobile"]
export const atMeta = ["atDns SOA"]